import { AxiosInstance } from "axios"
import {
    MerchantSalesMerchants,
    MerchantSalesMerchantsDetails,
    MerchantSalesReportData,
} from "../merchantSales/merchantSalesTypes"
import { MonetaryAmount } from "../../../../currency/currencyTypes"
import { DateType } from "../../../../../shared/components/filters/selectDateTypeFilter/SelectDateTypeFilter"
import { OrderFilterType } from "../../../../../shared/components/filters/orderTypeFilter/helpers"

export enum SupplierCustomerSalesQuery {
    CUSTOMER_SALES_FOR_SUPPLIER = "customer-sales-for-supplier",
    CUSTOMER_SALES_FOR_SUPPLIER_DETAILS = "customer-sales-for-supplier-details",
}

export type CustomerSalesParams = Readonly<{
    supplierId: number
    shopTypes: string
    paymentMethods: string
    startDate: string
    endDate: string
    orderType: OrderFilterType
    dateType: DateType
}>

export type CustomerSalesDetailsParams = Readonly<{
    supplierId: number
    customerId: number
    shopTypes?: string
}>

export type SupplierCustomerSalesResponse = Readonly<{
    reportDetails: MerchantSalesReportData
    merchants: Array<MerchantSalesMerchants>
    totalBookedSales: MonetaryAmount
    totalUpcomingSales: MonetaryAmount
}>

export type SupplierCustomerSalesDetailsResponse = Readonly<{
    reportDetails: MerchantSalesReportData
    merchants: MerchantSalesMerchantsDetails
    totalBookedSales: MonetaryAmount
    totalUpcomingSales: MonetaryAmount
}>

export async function fetchCustomerSales(
    { supplierId, startDate, endDate, shopTypes, paymentMethods, orderType, dateType }: CustomerSalesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierCustomerSalesResponse> {
    const url = `/suppliers/${supplierId}/accounting/customer/sales`
    const { data } = await axios.get(url, {
        params: {
            shopTypes,
            paymentMethods,
            startDate,
            endDate,
            orderType,
            dateType,
        },
        signal,
    })

    return data
}

export async function fetchCustomerSalesDetails(
    { supplierId, shopTypes, customerId }: CustomerSalesDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierCustomerSalesDetailsResponse> {
    const url = `/suppliers/${supplierId}/accounting/customers/${customerId}/salesPerCategory`

    const { data } = await axios.get(url, {
        params: {
            shopTypes,
        },
        signal,
    })

    return data
}
